import { bodyCommon, typography } from "@bevco/Utilities/styleguide/Typography";
import { colorStrings, mediaQueriesBP } from "@bevco/Utilities/variables";
import { LinkPresentationProps, StyledTypography } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const commonLinkStyles = css`
    display: inline-flex;
    position: relative;

    &:hover {
        &&&& span {
            text-decoration: underline;
            text-underline-offset: 2px;
            color: ${getColor(colorStrings.primaryMain)};
        }
    }
`;

export const customLinkHoverStyles = css`
    &::after {
        content: "";
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: ${getColor(colorStrings.primaryMain)};
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
    }

    &:hover {
        color: ${getColor(colorStrings.primaryMain)};
        &::after {
            transform: scaleX(1);
            transform-origin: bottom left;
        }
    }
`;

export const link: RecursivePartial<{
    defaultProps?: LinkPresentationProps | undefined;
}> = {
    defaultProps: {
        typographyProps: {
            ...bodyCommon,
        },
        css: css`
            /* Verndale Customization -- Start */
            ${commonLinkStyles}

            &.list-link, &.list-title, &.navigation-list-link {
                &&&& span {
                    color: ${getColor(colorStrings.commonGlobalBlack)};

                    &:hover {
                        color: ${getColor(colorStrings.commonGlobalBlack)};
                    }
                }
            }

            /* Verndale Customization -- End */
        `,
    },
};
